var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 165.9 31.5",
    style: {
      enableBackground: "new 0 0 165.9 31.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .st0 {\n            fill: #FFFFFF;\n        }\n\n        .st1 {\n            fill: #0096FF;\n        }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.3,18.2c0,7.6-6.1,13.4-14.2,13.4S-0.1,25.9-0.1,18.2C-0.1,10.7,6.1,5,14.1,5C22.3,4.9,28.3,10.6,28.3,18.2             z M6.8,18.2c0,4.4,3.4,7.8,7.4,7.8s7.2-3.4,7.2-7.8c0-4.4-3.2-7.7-7.2-7.7C10.2,10.5,6.8,13.8,6.8,18.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "146.2,16.1 150.4,21.4 149.1,23.8 141.2,23.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "140.8,5.2 148.4,5.2 151.4,9.8 155.4,14.9 164.7,28.1 156.9,28.1 151.4,19.9 147.2,14.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.4,14.3c0-5.8-4-9.1-10.9-9.1H31.8v26.1h6.7v-7.4v-5.2v-5.3v-3h5c2.9,0,4.6,1.4,4.6,4.1                 c0,2.8-1.7,4.2-4.6,4.2h-3.3v5.2h3.3h0.2l3.9,7.4h7.5l-5.5-8.6C52.7,21.1,54.4,18.3,54.4,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.1,5.2H58.9v26.1h6.7V26V13.5v-2.9h4.4c4.2,0,7.3,3.2,7.3,7.8s-2.9,7.7-7,7.7h-3v5.3h2.6                 c8.4,0,14.2-5.3,14.2-13.1C83.9,10.5,78.4,5.2,70.1,5.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "94.2,10.4 107.9,10.4 107.9,5.2 87.6,5.2 87.6,31.3 108.4,31.3 108.4,26.1 94.2,26.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.9,
    y: 15.6,
    className: "st0",
    width: 10.6,
    height: 5.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.6,22.8c3.1-1.5,4.7-4.4,4.7-8.4c0-5.8-4-9.1-10.9-9.1h-11.7v26.1h6.7V10.4h5c2.9,0,4.6,1.4,4.6,4.1                 c0,2.8-1.7,4.2-4.6,4.2h-3.2v5.2h3.2h0.2l3.9,7.4h7.5L130.6,22.8z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "165.9,-0.2 156.6,13.3 152.6,8.3 158.4,-0.2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderxLogo);
export default __webpack_public_path__ + "static/media/orderx-logo.8b101c0915b0327162b24b031a599240.svg";
export { ForwardRef as ReactComponent };